import ServiceCta from './CTA/ServiceCta';
import ServiceWebCallback from './WebCallback/ServiceWebCallback';
import ServiceReglette from "@components/ServiceModule/Reglette/RegletteOverlay";
import ServiceNutritionAskRange from "@components/ServiceModule/NutritionAskRange/NutritionAskRange";

const ServiceModule = () => {
  ServiceReglette();
  ServiceWebCallback();
  ServiceCta();
  ServiceNutritionAskRange();
};

export default ServiceModule;
